import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import './style.css';
const containerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
    lat: 38.6316261,
    lng: -77.2721974,
};

const GoogleMapWithDirections = ({ apiKey }) => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: apiKey
      })
    
      const [map, setMap] = React.useState(null)
    
      const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
    
        setMap(map)
      }, [])
    
      const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
      }, [])
    
      return isLoaded ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
          >
            { /* Child components, such as markers, info windows, etc. */ }
            <></>
          </GoogleMap>
      ) : <></>
};

export default GoogleMapWithDirections;
